import { Component, OnInit, NgZone, ViewChild, AfterContentInit } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { SharedService } from 'src/app/shared.service';
import { TranslateService } from '@ngx-translate/core';
import {ActivatedRoute, Router} from "@angular/router";
import { FormGroup, FormControl, Validators } from '@angular/forms';
import {PageEvent} from '@angular/material/paginator';
import { MatRadioChange } from '@angular/material/radio';
import {MatSnackBar} from '@angular/material/snack-bar';
import {CdkTextareaAutosize} from '@angular/cdk/text-field';
import {take} from 'rxjs/operators';
import { ExternalComponent } from '../external.component';

@Component({
  selector: 'app-forgotpassword',
  templateUrl: './forgotpassword.component.html',
  styleUrls: ['./forgotpassword.component.css']
})
export class ForgotpasswordComponent implements OnInit {

  constructor(public parent: ExternalComponent, private service:SharedService, private cookieService: CookieService, public translate: TranslateService, private route: ActivatedRoute, private router:Router) { }

  ngOnInit(): void {
    this.getParamValues();
  }

  UserID:string;

  getParamValues() {
    this.route.queryParams.subscribe(params => {   
      
      if(params['u']){
        this.UserID = params['u'];
      }
     
    });

    if(this.UserID != undefined && this.UserID != null){
      
    }
  }

}
